import { TypedUseSelectorHook, useSelector } from 'react-redux';
import type { RootState } from '../data/store';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
